const mediaItems = [
  {
    title: '顶流艺人私下交易全程录像曝光',
    duration: '12:38',
    views: '45.6万',
    image: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20with%20central%20dramatic%20warm%20glow%20reminiscent%20of%20video%20thumbnail%2C%20deep%20charcoal%20background%20with%20subtle%20play%20icon%20shape%2C%20entertainment%20news%20theme%2C%20professional%20dark%20media%20aesthetic%2C%20no%20text%20or%20people&width=700&height=420&seq=media-01-hlv&orientation=landscape',
  },
  {
    title: '知名企业财报造假内部会议录音',
    duration: '08:15',
    views: '32.8万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dark%20corporate%20video%20thumbnail%20style%20with%20amber%20geometric%20highlight%2C%20professional%20investigative%20journalism%20theme%2C%20deep%20shadow%20composition%2C%20no%20text%20or%20people&width=700&height=420&seq=media-02-hlv&orientation=landscape',
  },
  {
    title: '综艺节目录制现场冲突完整版',
    duration: '15:42',
    views: '58.3万',
    image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20abstract%20with%20intersecting%20crimson%20light%20streaks%20on%20charcoal%20background%2C%20television%20studio%20theme%20vibe%2C%20video%20platform%20aesthetic%2C%20no%20text%20or%20people&width=700&height=420&seq=media-03-hlv&orientation=landscape',
  },
  {
    title: '网红MCN霸王条款签约现场偷拍',
    duration: '10:05',
    views: '27.1万',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dark%20composition%20with%20warm%20glowing%20circular%20focus%20point%20on%20deep%20background%2C%20social%20media%20theme%2C%20cinematic%20video%20thumbnail%20style%2C%20no%20text%20or%20people&width=700&height=420&seq=media-04-hlv&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10 flex-wrap gap-3">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-900">
              视频精选
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mt-2">
              社区最受关注的热门视频内容
            </p>
          </div>
          <a
            href="#carousel"
            className="text-sm text-primary-600 font-medium hover:text-primary-700 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item, i) => (
            <article
              key={i}
              className="group bg-background-100 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer hover:border-primary-300/40 transition-all"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors" />
                <span className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-white text-xl group-hover:bg-primary-500 transition-all group-hover:scale-110">
                    <i className="ri-play-fill" />
                  </span>
                </span>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-white text-[10px] font-medium">
                  {item.duration}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug line-clamp-2 mb-2">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500 flex items-center gap-1">
                  <i className="ri-eye-line" />
                  {item.views}次观看
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}